import { ITempAddress } from "../../../interfaces/temp.interface"
import { IStoreLocation } from "../../../models/data.interface"
import { IGeoSearchProvider } from "../../../services/geo-search/geo-search-provider.interface"

export interface IDeliveryAddress {
    locationId: string,
    locations: IStoreLocation[],
    randomId: number,
    selectedStoreKey: string,
    selectedAddress: ITempAddress | null,
    streetAddress: string,
    apartment: string,
    deliveryInstructions: string,
    geoSearchProvider: IGeoSearchProvider
}

export interface IDeliveryAddressReferences {
    streetAddress: HTMLInputElement,
    datalist: HTMLDataListElement,
    datalistWv: HTMLUListElement,
    apartment: HTMLInputElement,
    deliveryInstructions: HTMLInputElement
}

export interface IFillInAddress {
    City: string,
    Latitude: number,
    Longitude: number,
    State: string,
    StName: string,
    StNo: string,
    StPreDirAbbr: string,
    StSuffixAbbr: string,
    StPostDirAbbr: string,
    ZipCode: string,
}

export enum ConfirmButtonState {
    ENABLED,
    DISABLED,
}